var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1567 10.3903C17.0357 10.271 16.8846 10.1867 16.7195 10.1466C16.5543 10.1065 16.3814 10.112 16.2192 10.1625C15.5901 10.3568 14.9351 10.4542 14.2767 10.4513C12.4926 10.4495 10.7821 9.74013 9.52052 8.47871C8.25892 7.21728 7.54927 5.50689 7.54728 3.72285C7.54498 3.06465 7.64298 2.40995 7.83791 1.78128C7.8888 1.61887 7.89451 1.44566 7.85444 1.28025C7.81437 1.11483 7.73002 0.963442 7.61044 0.842323C7.49086 0.721205 7.34057 0.634923 7.17568 0.592734C7.01079 0.550545 6.83753 0.554041 6.67447 0.602845C5.25133 1.03321 3.96401 1.82507 2.9381 2.9012C1.91218 3.97733 1.18269 5.30098 0.82077 6.74305C0.458852 8.18512 0.476867 9.69638 0.873056 11.1294C1.26925 12.5624 2.03008 13.8683 3.08136 14.9197C4.13264 15.9711 5.43846 16.732 6.87146 17.1283C8.30446 17.5247 9.81571 17.5428 11.2578 17.181C12.6999 16.8192 14.0236 16.0898 15.0999 15.064C16.1761 14.0382 16.9681 12.751 17.3985 11.3278C17.4473 11.1644 17.4506 10.9907 17.408 10.8255C17.3654 10.6603 17.2785 10.5098 17.1567 10.3903Z",
    fill: "#B2ABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.3cb100b955ffab5d79cf3eb50cfdf2b8.svg";
export { ForwardRef as ReactComponent };